if (!customElements.get('author-articles')) {
  class AuthorArticles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let q = this.getAttribute('data-tag');
      let url = this.getAttribute('data-url');

      if (!q || !url) return;

      url += `?view=articles&q=${q.split(':')[0]}:&type=article`;

      fetch(url)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser().parseFromString(data, 'text/html');

          parser
            .querySelectorAll(`article:not([data-author="${q}"])`)
            .forEach((element) => {
              element.remove();
            });

          this.innerHTML = parser.body.innerHTML.trim();
        })
        .catch((err) => console.error(err));
    }
  }

  customElements.define('author-articles', AuthorArticles);
}
